import { gql } from '@apollo/client';

import WORKDAYS from '../availabilities/workdays';
import AVATAR_FRAGMENT from '../avatar';
import COMPANY_FRAGMENT from '../company';
import CONTACTS_FRAGMENT from '../contacts';
import DOCUMENTS_FRAGMENT from '../documents';
import OTHER_EMAILS_FRAGMENT from '../otherEmails';
import TRANSACTIONS_FRAGMENT from '../transactions';
// import TRANSACTIONS_FRAGMENT from './transactions';

const USER_FRAGMENT = gql`
  ${AVATAR_FRAGMENT}
  ${WORKDAYS}
  ${OTHER_EMAILS_FRAGMENT}
  ${CONTACTS_FRAGMENT}
  ${DOCUMENTS_FRAGMENT}
  ${TRANSACTIONS_FRAGMENT}
  ${COMPANY_FRAGMENT}
  fragment UserFragment on User {
    id
    status
    # createdAt
    # updatedAt
    # deletedAt
    email
    role
    firstName
    lastName
    avatar {
      ...AvatarFragment
    }
    availability {
      ...Workdays
    }
    availabilityTimezone
    otherEmails {
      ...OtherEmailsFragment
    }
    contacts {
      ...ContactsFragment
    }
    documents {
      ...DocumentsFragment
    }
    address1
    address2
    city
    zip
    state
    paymentDetail
    paymentAddress
    # reviews
    isVerified
    userAddress
    docShippingAddress
    companyRole
    emailDisable
    ableScanDoc
    assignedTransactions {
      ...TransactionsFragment
    }
    # notaryTransactions
    # createdTransactions
    company {
      ...CompanyFragment
    }
    # specificPrices
    inviteUrl
    usersLocations {
      id
      manageUsersPermission
      clientPermission
      location {
        number
        id
        name
        address
      }
    }
    isAssignedTransaction
    mainLocation {
      id
      name
    }
  }
`;

export default USER_FRAGMENT;
